// extracted by mini-css-extract-plugin
export default {"wrapper":"GameHelpModal_wrapper__4pdMk"};